<template>
	<v-container fluid>
		<div class="d-flex flex-wrap py-2">
			<v-btn class="ma-1" color="primary" small @click="getFacturas">
				<v-icon left>mdi-reload</v-icon>Recargar
			</v-btn>
		</div>
		<v-card>
			<v-data-table
				fixed-header
				:items="facturas"
				:headers="facturasHeader"
				show-select
				item-key="IdCarteraCobro"
				v-model="selected"
				:single-select="false"
				:calculate-widths="true"
				:search="search"
				:loading="loading"
				:footer-props="{
					showFirstLastPage: true,
					showCurrentPage: true,
					itemsPerPageOptions: [10, 25, 50],
				}"
				checkbox-color="secondary"
			>
				<template v-slot:body.prepend="{ headers }">
					<table-filters :headers="headers" :items="facturas" v-model="inlineFilters"></table-filters>
				</template>

				<template v-slot:item.estado="{ item }">
					<!-- {{ [item.IdFacturaVentaCabecera, item.IdCarteraCobro] }} -->
					<status-chip :value="(item.estado)" />
				</template>

				<template v-slot:item.FechaFactura="{ item }">
					<span v-text="parseDate(item.FechaFactura)"></span>
				</template>
				<template v-slot:item.FechaLecturaAnteriorXML="{ item }">
					<span v-text="parseDate(item.FechaLecturaAnteriorXML)"></span>
				</template>
				<template v-slot:item.FechaLecturaActualXML="{ item }">
					<span v-text="parseDate(item.FechaLecturaActualXML)"></span>
				</template>

				<template v-slot:item.ImporteBase="{ item }">
					<span v-text="parseFloat(item.ImporteBase).toFixed(2) + ' €'" />
				</template>
				<template v-slot:item.ImporteImpuesto="{ item }">
					<span v-text="`${parseFloat(item.ImporteImpuesto).toFixed(2)} €`" />
					&nbsp;
					<code>({{ item.PorcentajeImpuesto * 1 }}%)</code>
				</template>
				<template v-slot:item.ImporteTotal="{ item }">
					<span class="font-weight-bold" v-text="parseFloat(item.ImporteTotal).toFixed(2) + ' €'" />
				</template>

				<template v-slot:item.NumeroFactura="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								@click="verPDFfactura(item.IdDocumento)"
								color="secondary"
								text
								:disabled="!!pdfId || !item.IdDocumento"
								:loading="pdfId == item.IdDocumento && pdfId !== null"
							>
								{{ item.SerieFactura }} {{ item.NumeroFactura }}
								<v-icon right>{{ item.IdDocumento ? "mdi-file-document-edit-outline" : 'mdi-file-cancel-outline' }}</v-icon>
							</v-btn>
						</template>
						<span>Ver PDF factura</span>
					</v-tooltip>
				</template>

				<template v-slot:item.CodigoContrato="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								:to="`/detalles_contrato?codigoContrato=${item.CodigoContrato}&idContrato=${item.IdContrato}`"
								color="secondary"
								text
							>{{ item.CodigoContrato }}</v-btn>
						</template>
						<span>Detalles del contrato</span>
					</v-tooltip>
				</template>

				<template v-slot:item.Identificador="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								link
								:to="`/detalles_cliente?idCliente=${item.IdCliente}`"
								color="secondary"
								text
							>{{ item.Identificador }}</v-btn>
						</template>
						<span>Detalles del cliente</span>
					</v-tooltip>
				</template>

				<template v-slot:item.acciones="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-on="on"
								v-bind="attrs"
								@click="detailsId = [item.IdCarteraCobro, item.IdFacturaVentaCabecera]"
								icon
								color="secondary"
							>
								<v-icon>mdi-eye</v-icon>
							</v-btn>
						</template>
						Ver detalles
					</v-tooltip>
				</template>
			</v-data-table>
		</v-card>

		<div class="d-flex flex-wrap mt-4 align-center">
			<strong class="mr-2">Total importes {{ selected.length == 0 ? 'registros filtrados' : 'registros seleccionados' }} :</strong>
			{{ acumuladoFacturas }}
			<v-btn
				text
				color="primary"
				class="ml-2"
				small
				:disabled="selected.length == 0"
				@click="selected = []"
			>Deseleccionar todos ({{ selected.length }})</v-btn>
		</div>

		<v-dialog
			:value="detailsId[0]"
			@input="(v) => v === false ? detailsId = [] : null"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card>
				<v-toolbar color="primary">
					<v-toolbar-title class="white--text">Detalles factura Cod {{ detailsId[0] }}</v-toolbar-title>
					<v-spacer></v-spacer>

					<v-btn color="white" icon @click="detailsId = []">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<template v-if="$root.acceso('CONTROL_IMPAGADOS')">
					<v-tabs v-model="tab">
						<v-tab>Control factura</v-tab>
						<v-tab>Histórico llamadas</v-tab>
						<v-tab>Detalles factura</v-tab>
					</v-tabs>

					<v-tabs-items v-model="tab">
						<v-tab-item>
							<detalles-impagados
								@close="detailsId = []"
								:IdCarteraCobro="detailsId[0]"
								v-if="detailsId[0]"
								:key="detailsId[0]"
							/>
						</v-tab-item>
						<v-tab-item>
							<historico-llamadas
								@close="detailsId = []"
								:IdCarteraCobro="detailsId[0]"
								v-if="detailsId[0]"
								:key="detailsId[0]"
							/>
						</v-tab-item>
						<v-tab-item>
							<detalles-factura
								@close="detailsId = []"
								:idFactura="detailsId[1]"
								v-if="detailsId[1]"
								:key="detailsId[1]"
							/>
						</v-tab-item>
					</v-tabs-items>
				</template>

				<detalles-factura
					v-else-if="detailsId[1]"
					@close="detailsId = []"
					:idFactura="detailsId[1]"
					:key="detailsId[1]"
				/>
			</v-card>
		</v-dialog>

		<!-- <v-dialog
			:value="detailsId"
			@input="(v) => v === false ? detailsId = null : null"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card class="rounded-0">
				<v-toolbar color="primary" class="white--text">
					<v-toolbar-title>Detalles Factura</v-toolbar-title>
					<v-spacer />
					<v-btn color="white" icon @click="detailsId = null">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-card-text>
					<detalles-facturacion :idFactura="detailsId" v-if="detailsId" :key="detailsId"></detalles-facturacion>
				</v-card-text>
			</v-card>
		</v-dialog>-->
	</v-container>
</template>

<script>
import { getSituacionIcon, perColumnFilter, parseDate, downloadFile } from "@/utils/index.js";

export default {
	components: {
		StatusChip: () => import("@/components/StatusChip.vue"),
		TableFilters: () => import("@/components/TableFilters.vue"),
		DetallesFactura: () => import("@/views/facturacionContratos/DetallesFactura.vue"),
		DetallesImpagados: () => import("@/views/impagados/DetallesImpagados.vue"),
		HistoricoLlamadas: () => import("@/views/impagados/HistoricoLlamadas.vue"),
	},
	props: ['codigoContrato'],
	computed: {
		acumuladoFacturas() {
			if (this.selected.length) {
				return parseFloat(this.selected.reduce((a, c) => a + Number(c.ImporteTotal), 0)).toFixed(2) + ' €'
			} else {
				// return parseFloat(this.facturas.reduce((a, c) => a + Number(c.ImporteTotal), 0)).toFixed(2) + ' €'
				const getDatatype = (key) =>
					(this.facturasHeader.find((h) => h.value == key) || {}).dataType;

				return parseFloat(this.facturas.filter((con) =>
					Object.entries(con).every(([key, value]) =>
						perColumnFilter(value, this.inlineFilters[key], getDatatype(key))
					)
				).map(i => Number(i.ImporteTotal)).reduce((a, c) => a + c, 0)).toFixed(2) + ' €'
			}
		}
	},
	data() {
		return {
			debounce: true,
			loading: true,
			page: 2,
			selected: [],
			tab: 0,
			search: null,
			detailsId: [],
			pdfId: false,
			facturas: [],
			facturasHeader: [
				{ text: "Estado", value: "estado", dataType: 'select' },
				{
					text: "Acciones",
					value: "acciones",
					sortable: false,
					filterable: false,
				},
				{ text: "NºDoc", value: "NumeroFactura" },
				{ text: "Fecha", dataType: "date", value: "FechaFactura" },
				{ text: "Canal", dataType: "select", value: "Canal" },
				{ text: "Contrato", value: "CodigoContrato" },
				{ text: "Cliente", value: "Identificador" },
				{ text: "Nombre cliente", value: "Denominacion" },
				// { text: "Detalles", value: "detalles" },
				{ text: "Importe base", value: "ImporteBase" },
				{ text: "Importe Impuesto", value: "ImporteImpuesto" },
				{ text: "Total", value: "ImporteTotal" },
				{ text: "Lectura Anterior", dataType: 'date', value: "FechaLecturaAnteriorXML" },
				{ text: "Fecha Lectura", dataType: 'date', value: "FechaLecturaActualXML" },
			].map((header) =>
			({
				class: "text-no-wrap sticky-header",
				cellClass: "pa-2 text-no-wrap",
				filter: (value) =>
					perColumnFilter(
						value,
						this.inlineFilters[header.value],
						header.dataType
					),
				dataType: "text",
				...header,
			})
			),

			inlineFilters: {},
			comboboxes: {},
			loadingPDF: null,
		};
	},
	methods: {
		getSituacionIcon,
		parseDate,
		async getFacturas() {
			this.loading = true;
			const { data: facturas } = await axios({ url: `${process.env.VUE_APP_OUR_API_URL}/facturacion.php`, method: 'GET', params: { token: this.$store.getters.getJwtEmpresa, codigoContrato: this.codigoContrato } });
			// console.log(facturas.map(({ IdFacturaVentaCabecera, IdRemesaCobro, IdRemesaImpagadoCobro }) => ({ IdFacturaVentaCabecera, IdRemesaCobro, IdRemesaImpagadoCobro })))
			this.facturas = facturas.map(f => {
				switch (Number(f.CodigoSituacionCobro)) {
					case 0: f.estado = 'Sin Especificar'; break;
					case 1: f.estado = 'Pendiente'; break;
					case 2: f.estado = 'Cobrado'; break;
					case 3: f.estado = 'Impagado'; break;
					case 4: f.estado = 'Remesado'; break;
					case 5: f.estado = 'Carta Aviso'; break;
					case 6: f.estado = 'Carta Corte'; break;
					case 7: f.estado = 'Cortado'; break;
					case 8: f.estado = 'Cobrado norma 57'; break;
					case 9: f.estado = 'Cancelado por abono'; break;
					case 10: f.estado = 'Carta Corte 1'; break;
					case 11: f.estado = 'Carta Deuda'; break;
					case 12: f.estado = 'Fraccionado'; break;
				}
				f.Denominacion = f.RazonSocialTitular || [f.NombreTitular, f.Apellido1Titular, f.Apellido2Titular].filter((i) => !!i).join(" ");
				return f;
			});

			this.loading = false;
		},
		verPDFfactura(idDocumento) {
			this.pdfId = idDocumento
			let str = this.$store.getters.getDatosEmpresa;
			const { IdUsuario } = str.iss;
			const IdEmpresa = this.$store.getters.getIdEmpresa;
			axios({
				method: "get",
				url: `${process.env.VUE_APP_API_URL}/FacturaVentaCabecera/FacturaPreviewPDF/Empresa/${IdEmpresa}/Usuario/${IdUsuario}/Documento/${idDocumento}`,
				responseType: "blob",
			})
				.then((res) => {
					let pdf = new File(
						[res.data],
						`factura_${new Date().getTime()}.pdf`,
						{
							type: "application/pdf",
						}
					);
					downloadFile(pdf, true);
					this.pdfId = null
				})
				.catch((err) => {
					this.$root.$emit("snack", "Ha ocurrido un error");
					this.pdfId = null
				});
		},
	},
	mounted() {
		this.getFacturas();
	},
};
</script>

<style scoped>
.v-data-table /deep/ [role="columnheader"] {
	/* background: #f1f1f1 !important; */
}
</style>
